import { render, staticRenderFns } from "./RsaRegistrazioneUsciteEntrateModalEditComponent.vue?vue&type=template&id=ddc3e9d4&scoped=true"
import script from "./RsaRegistrazioneUsciteEntrateModalEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaRegistrazioneUsciteEntrateModalEditComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaRegistrazioneUsciteEntrateModalEditComponent.vue?vue&type=style&index=0&id=ddc3e9d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc3e9d4",
  null
  
)

export default component.exports